import { useEffect, useState } from "react";
import api from "@/lib/api";
import CrmFileImage from "@/components/crm/CrmFileImage";

let _cache = null;
/** Liste des banques actives (Configuration › Listes), chargée une fois par session. */
export function useBanks() {
  const [banks, setBanks] = useState(_cache || []);
  useEffect(() => { if (_cache) return; api.get("/crm/lists").then(({ data }) => { _cache = (data.banques || []).filter((b) => b.active); setBanks(_cache); }).catch(() => {}); }, []);
  return banks;
}
export const invalidateBanks = () => { _cache = null; };

const norm = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, " ").trim();

/** Initiales d'une banque : sigle entre parenthèses, sinon `short`, sinon initiales des mots (max 4). */
export const bankInitials = (item) => {
  const label = typeof item === "string" ? item : item?.label || "";
  const paren = label.match(/\(([^)]+)\)/);
  if (paren) return paren[1].toUpperCase().slice(0, 4);
  if (item?.short && item.short.length <= 4) return item.short.toUpperCase();
  return label.split(/\s+/).filter((w) => w.length > 2 && !/^(de|du|des|la|le|les|d|l|for|and|the|et)$/i.test(w)).map((w) => w[0]).join("").toUpperCase().slice(0, 4) || "?";
};

/** Compte existant : texte « Banque » libre → entrée de la liste si nom complet, sigle ou libellé sans parenthèses correspond (aucune écriture). */
export const matchBank = (text, items = []) => {
  const t = norm(text);
  if (!t) return null;
  const words = new Set(t.split(" "));
  return items.find((it) => { const lbl = norm(it.label), bare = norm(it.label.replace(/\([^)]*\)/g, "")), sh = norm(it.short); return lbl === t || bare === t || (sh && (sh === t || words.has(sh))) || (bare && t.includes(bare)); }) || null;
};

/** Pastille blanche (24 × 24 par défaut, rayon 6, marge 2) : logo contenu (statique `/banks/…` ou `crm:<file_id>` B2) ; sans logo → initiales. iter435 pt 1 : `radius` / `pad` paramétrables, le logo remplit le carré (object-fit contain). */
export function BankLogo({ item, size = 24, radius = 6, pad = 2, testId }) {
  const logo = item?.logo;
  const ini = bankInitials(item);
  const inner = size - pad * 2;
  return (
    <span className="inline-flex items-center justify-center shrink-0 overflow-hidden" title={item?.label} style={{ width: size, height: size, borderRadius: radius, background: "#fff", padding: pad, boxSizing: "border-box" }} data-testid={testId} data-logo={logo ? "image" : "initials"}>
      {logo ? (logo.startsWith("crm:") ? <CrmFileImage fileId={logo.slice(4)} alt="" className="block object-contain" style={{ width: inner, height: inner, maxWidth: "none" }} /> : <img src={logo} alt="" className="block object-contain" style={{ width: inner, height: inner, maxWidth: "none" }} draggable={false} />)
        : <span style={{ fontSize: Math.max(6.5, Math.round(size * (ini.length > 3 ? 0.27 : 0.34))), fontWeight: 700, color: "#1f1f24", letterSpacing: ".02em", lineHeight: 1 }}>{ini}</span>}
    </span>
  );
}
